import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tabs"
export default class extends Controller {
  static targets = [ "trigger", "panel" ]
  static classes = [ "active", "inactive" ]
  static values = {
    defaultTab: String,
    activeTab: String,
    paramName: String
  }

  connect() {
    const initial = this.currentTabFromUrl() || this.defaultTabValue || this.triggerTargets[0]?.dataset[this.tabDatasetKey]
    if (!this.hasActiveTabValue && initial) {
      this.activeTabValue = initial
    }

    this.update()
  }

  show(event) {
    event.preventDefault()
    const params = event.params || {}
    const tabParam = typeof params.tab === "string" ? params.tab : null
    const currentTarget = event.currentTarget
    const datasetTab = currentTarget && currentTarget.dataset ? currentTarget.dataset[this.tabDatasetKey] : null
    const tab = tabParam || datasetTab
    if (tab && tab !== this.activeTabValue) {
      this.activeTabValue = tab
      this.update()
    }
  }

  update() {
    const active = this.activeTabValue

    this.triggerTargets.forEach((trigger) => {
      const isActive = trigger.dataset[this.tabDatasetKey] === active
      trigger.setAttribute("aria-selected", isActive)
      trigger.setAttribute("tabindex", isActive ? "0" : "-1")

      this.activeClasses.forEach((className) => trigger.classList.toggle(className, isActive))
      this.inactiveClasses.forEach((className) => trigger.classList.toggle(className, !isActive))
    })

    this.panelTargets.forEach((panel) => {
      const isActive = panel.dataset[this.panelDatasetKey] === active
      panel.hidden = !isActive
      panel.setAttribute("aria-hidden", (!isActive).toString())
    })

    this.syncUrl(active)
  }

  get activeClasses() {
    if (!this.hasActiveClass) return []
    return this.activeClass.split(/\s+/).filter(Boolean)
  }

  get inactiveClasses() {
    if (!this.hasInactiveClass) return []
    return this.inactiveClass.split(/\s+/).filter(Boolean)
  }

  get identifierPrefix() {
    return this.identifier.replace(/-(\w)/g, (_match, char) => char.toUpperCase())
  }

  get tabDatasetKey() {
    return `${this.identifierPrefix}Tab`
  }

  get panelDatasetKey() {
    return `${this.identifierPrefix}Panel`
  }

  get paramName() {
    return this.paramNameValue || null
  }

  currentTabFromUrl() {
    if (!this.paramName) return null
    try {
      const url = new URL(window.location.href)
      const value = url.searchParams.get(this.paramName)
      return value || null
    } catch (_e) {
      return null
    }
  }

  syncUrl(value) {
    if (!this.paramName || typeof window === "undefined" || typeof history === "undefined") return

    try {
      const url = new URL(window.location.href)
      url.searchParams.set(this.paramName, value)
      history.replaceState({}, "", url.toString())
    } catch (_e) {
      // no-op if URL parsing fails
    }
  }
}
